import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6981932d&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=6981932d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981932d",
  null
  
)

export default component.exports